import secureStorage from '../controllers/secureStorage';

export function getFieldSettings() {
  const clpSitePageSettings = secureStorage.getItem('clpSitePageSettings');
  if (clpSitePageSettings) {
    const _fieldSettings = clpSitePageSettings.field_settings;
    try {
      return JSON.parse(_fieldSettings);
    } catch (e) {
      console.error('Failed to parse field settings:', e);
      return null;
    }
  }
  return null;
}


export function getClpSitePageSettings() {
  const clpSitePageSettings = secureStorage.getItem('clpSitePageSettings');
  
  if (clpSitePageSettings) {
    const _clpSitePageSettings = clpSitePageSettings;
    try {
      return _clpSitePageSettings;
    } catch (e) {
      console.error('Failed to parse clp site settings:', e);
      return null;
    }
  }
  return null;
}

